export const barbers = [
  {
    id: 1,
    firstName: 'Alex',
    lastName: 'Khismatulin',
    photo: 'https://via.placeholder.com/400',
    services: [
      {
        id: 2,
        name: 'Kids cut (under 12yrs)',
        price: 5000,
        currency: 'usd',
        duration: 45,
      },
      {
        id: 3,
        name: 'Signature clipper cut',
        price: 4000,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 5,
        name: 'Beard Trim',
        price: 8000,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 6,
        name: 'Premium Cut',
        price: 15000,
        currency: 'usd',
        duration: 90,
      },
    ],
  },
  {
    id: 2,
    firstName: 'Derek',
    lastName: 'Labo',
    photo: 'https://via.placeholder.com/400',
    services: [
      {
        id: 1,
        name: 'Advanced style scissor cut',
        price: 7500,
        currency: 'usd',
        duration: 40,
      },
      {
        id: 2,
        name: 'Kids cut (under 12yrs)',
        price: 5000,
        currency: 'usd',
        duration: 45,
      },
      {
        id: 3,
        name: 'Signature clipper cut',
        price: 4000,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 4,
        name: 'Mens clipper cut',
        price: 7500,
        currency: 'usd',
        duration: 75,
      },
      {
        id: 6,
        name: 'Premium Cut',
        price: 15000,
        currency: 'usd',
        duration: 90,
      },
    ],
  },
  {
    id: 3,
    firstName: 'Isais',
    lastName: 'Geidel',
    photo: 'https://via.placeholder.com/400',
    services: [
      {
        id: 1,
        name: 'Advanced style scissor cut',
        price: 7500,
        currency: 'usd',
        duration: 40,
      },
      {
        id: 3,
        name: 'Signature clipper cut',
        price: 4000,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 4,
        name: 'Mens clipper cut',
        price: 7500,
        currency: 'usd',
        duration: 75,
      },
      {
        id: 6,
        name: 'Premium Cut',
        price: 15000,
        currency: 'usd',
        duration: 90,
      },
      {
        id: 8,
        name: 'Executive package',
        price: 9500,
        currency: 'usd',
        duration: 75,
      },
    ],
  },
  {
    id: 4,
    firstName: 'Aaron',
    lastName: 'Wickwire',
    photo: 'https://via.placeholder.com/400',
    services: [
      {
        id: 4,
        name: 'Mens clipper cut',
        price: 7500,
        currency: 'usd',
        duration: 75,
      },
      {
        id: 5,
        name: 'Beard Trim',
        price: 8000,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 6,
        name: 'Premium Cut',
        price: 15000,
        currency: 'usd',
        duration: 90,
      },
      {
        id: 7,
        name: 'Haircut & hot towel',
        price: 7500,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 8,
        name: 'Executive package',
        price: 9500,
        currency: 'usd',
        duration: 75,
      },
      {
        id: 9,
        name: 'Baldy shave',
        price: 5000,
        currency: 'usd',
        duration: 30,
      },
    ],
  },
  {
    id: 5,
    firstName: 'Nick',
    lastName: 'Kehoe',
    photo: 'https://via.placeholder.com/400',
    services: [
      {
        id: 1,
        name: 'Advanced style scissor cut',
        price: 7500,
        currency: 'usd',
        duration: 40,
      },
      {
        id: 2,
        name: 'Kids cut (under 12yrs)',
        price: 5000,
        currency: 'usd',
        duration: 45,
      },
      {
        id: 4,
        name: 'Mens clipper cut',
        price: 7500,
        currency: 'usd',
        duration: 75,
      },
      {
        id: 5,
        name: 'Beard Trim',
        price: 8000,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 6,
        name: 'Premium Cut',
        price: 15000,
        currency: 'usd',
        duration: 90,
      },
    ],
  },
  {
    id: 6,
    firstName: 'Jesse',
    lastName: 'D’Acquisto',
    photo: 'https://via.placeholder.com/400',
    services: [
      {
        id: 2,
        name: 'Kids cut (under 12yrs)',
        price: 5000,
        currency: 'usd',
        duration: 45,
      },
      {
        id: 5,
        name: 'Beard Trim',
        price: 8000,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 6,
        name: 'Premium Cut',
        price: 15000,
        currency: 'usd',
        duration: 90,
      },
    ],
  },
  {
    id: 7,
    firstName: 'Douglas',
    lastName: 'Charney',
    photo: 'https://via.placeholder.com/400',
    services: [
      {
        id: 4,
        name: 'Mens clipper cut',
        price: 7500,
        currency: 'usd',
        duration: 75,
      },
      {
        id: 5,
        name: 'Beard Trim',
        price: 8000,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 6,
        name: 'Premium Cut',
        price: 15000,
        currency: 'usd',
        duration: 90,
      },
      {
        id: 7,
        name: 'Haircut & hot towel',
        price: 7500,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 8,
        name: 'Executive package',
        price: 9500,
        currency: 'usd',
        duration: 75,
      },
      {
        id: 9,
        name: 'Baldy shave',
        price: 5000,
        currency: 'usd',
        duration: 30,
      },
    ],
  },
  {
    id: 8,
    firstName: 'Isais',
    lastName: 'Gago',
    photo: 'https://via.placeholder.com/400',
    services: [
      {
        id: 1,
        name: 'Advanced style scissor cut',
        price: 7500,
        currency: 'usd',
        duration: 40,
      },
      {
        id: 2,
        name: 'Kids cut (under 12yrs)',
        price: 5000,
        currency: 'usd',
        duration: 45,
      },
      {
        id: 4,
        name: 'Mens clipper cut',
        price: 7500,
        currency: 'usd',
        duration: 75,
      },
      {
        id: 5,
        name: 'Beard Trim',
        price: 8000,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 6,
        name: 'Premium Cut',
        price: 15000,
        currency: 'usd',
        duration: 90,
      },
    ],
  },
  {
    id: 9,
    firstName: 'Brendan',
    lastName: 'Bacca',
    photo: 'https://via.placeholder.com/400',
    services: [
      {
        id: 2,
        name: 'Kids cut (under 12yrs)',
        price: 5000,
        currency: 'usd',
        duration: 45,
      },
      {
        id: 5,
        name: 'Beard Trim',
        price: 8000,
        currency: 'usd',
        duration: 30,
      },
      {
        id: 6,
        name: 'Premium Cut',
        price: 15000,
        currency: 'usd',
        duration: 90,
      },
    ],
  },
];
